<script setup lang="ts">
const { error } = defineProps({
  error: Object,
})

interface StoryBlokError {
  items: {
    code: string
    title: string
    text: StoryBlokRichText
    image: StoryBlokImage
  }[]
  homeButton: StoryBlokButton[]
}

const isMenuOpen = ref(false)
const sbApi = useStoryblokApiV2()

const { stories } = await sbApi.getStories({
  by_slugs: ['layout/*'],
}) as any

const errorData: StoryBlokError = stories?.find((item: { slug: string }) => item.slug === 'error')?.content
const errorItems = errorData?.items || []
const errorItem = errorItems.find(item => Number(item.code) === error?.statusCode)!
</script>

<template>
  <div>
    <TheNavigation
      v-model:isMenuOpen="isMenuOpen"
      v-bind="stories.find((item: any) => item.slug === 'navigation')?.content"
    />
    <div class="flex pt-4 md:pt-10 flex flex-col relative bg-primary">
      <div class="px-5 z-1 flex flex-col text-center text-white">
        <div class="flex w-full justify-center">
          <StoryblokImage
            class="mt-8 sm:h-68 md:h-76"
            :src="errorItem.image"
          />
        </div>
        <h1 class="mt-8">
          {{ errorItem.title }}
        </h1>
        <StoryblokRichText :document="errorItem.text" />
        <div class="sm:flex mt-5 mb-11 md:mt-9 md:mb-15">
          <StoryblokButton v-bind="errorData.homeButton[0]" class="<sm:mx-auto" />
        </div>
      </div>
    </div>
    <TheFooter v-bind="stories.find((item: any) => item.slug === 'footer')?.content" />
  </div>
</template>
